import { BfAppContext, CoordinatesValue } from '@tw/tw-runtime';
import { ImageBackground, Text, View } from 'react-native';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useEffect, useMemo, useState } from 'react';
import { TwPage, TwSteps } from '@tw/tw-components-rn';

import { AddressInit } from './viewparts/address-init/AddressInit';
import { AddressProps } from './type';
import { CommonStore } from '@/app/core/store/common/common-store';
import { DepartmentSelect2 } from './viewparts/department-select/DepartmentSelect2';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { TwButton } from '@/app/components/tw-button/TwButton';
import background from './assets/background.png';
import { checkAddressParams } from '@/app/utils/utils';
import { styles } from './styles';
import { useAppStore } from '@tw/tw-runtime-react';

const checkParams = (addressProps: AddressProps) => {
  const { name, phone, address } = addressProps;
  return checkAddressParams(name, phone, address);
};

export const GiftDepartment = () => {
  const appStore = useAppStore();
  const [department, setDepartment] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [address, setAddress] = useState<AddressProps>({
    name: '',
    phone: '',
    address: undefined,
    isDefault: false
  });

  const [active, setActive] = useState(0);

  const onInputValueChange = (text: string) => {
    setInputValue(text);
    setDepartment(null);
  };

  const onDepartmentSelect = (department) => {
    setDepartment(department);
    setInputValue(department.name);
  };

  const content = useMemo(() => {
    return [
      <DepartmentSelect2
        enableSearch={true}
        inputValue={inputValue}
        department={department}
        onChange={onInputValueChange}
        onSelect={onDepartmentSelect}
        key={'key1'}
      />,
      <AddressInit value={address} onChange={setAddress} key={'key2'} />
    ];
  }, [address, department, inputValue]);

  return (
    <TwPage translucentStatusBar={true} style={styles.container}>
      <ImageBackground style={styles.image} source={background}>
        <TwSteps
          active={active}
          content={content}
          onBack={() => setActive((p) => p - 1)}
          onFinish={async () => {
            const isOk = checkParams(address) && department && department.id;
            if (!isOk) {
              BfAppContext.getInstance().getMessageService().showError('请填写完整信息');
              return;
            }

            await CommonStore.getInstance().initData({
              departmentId: {
                id: department.id
              },
              address: {
                linkmanName: address.name,
                linkmanMobile: address.phone,
                address: address.address,
                isDef: address.isDefault
              }
            });
            BfAppContext.getInstance().getMessageService().showSuccess('设置成功');
            BfAppContext.getInstance()
              .getUserStore()
              .setState((state) => {
                state.userInfo.employee.departmentId = department;
                return state;
              });
            BfAppContext.getInstance().getRouteService().replace({
              path: ROUTE_NAMES.HomeIndex
            });
          }}
          onNext={() => {
            if (department && department.id) {
              setActive((p) => p + 1);
            } else {
              BfAppContext.getInstance().getMessageService().showError('请选择部门');
            }
          }}
          firstStepBackButton={
            <TwButton
              variant={'ghost'}
              style={{
                position: 'relative',
                bottom: 0
              }}
              onPress={() => appStore.logout()}
              // size="sm"
              shape="round"
            >
              返回登录页面
            </TwButton>
          }
        />
      </ImageBackground>
    </TwPage>
  );
};
